/**
 * Auth error messages that indicate an expired or invalid session.
 * Used by Apollo error links to detect when to clear session and redirect to login.
 * Must match the exact error strings returned by the backend.
 */
export const IGNORED_AUTH_ERRORS = [
  "Signature verification failed",
  "Signature has expired",
  "400 Bad Request: The CSRF tokens do not match.",
  "400 Bad Request: The CSRF token is invalid.",
  "400 Bad Request: The CSRF token has expired.",
  "400 Bad Request: The CSRF token is missing.",
  "400 Bad Request: The CSRF session token is missing.",
  'Missing JWT in cookies or headers (Missing cookie "access_token_cookie"; Missing Authorization Header)',
];

/** Note text for an exam field with no custom default (backend llm/soap_helpers.py). */
export const NORMAL_ON_EXAM = "Normal on exam";

/** Exam fields with a custom default phrase, in settings order. */
export const APPOINTMENT_OBJECTIVE_NORMAL_DEFAULTS = [
  { name: "temperature", label: "Temperature" },
  { name: "heartRate", label: "Heart Rate" },
  { name: "weight", label: "Weight" },
  { name: "respiratoryRate", label: "Respiratory Rate" },
  { name: "capillaryRefillTime", label: "Capillary Refill Time" },
  { name: "mucousMembranes", label: "Mucous Membranes" },
  { name: "hydrationStatus", label: "Hydration Status" },
  { name: "bodyConditionScore", label: "Body Condition Score" },
  { name: "painScore", label: "Pain Score" },
  { name: "fearAnxietyStressScore", label: "Fear Anxiety Stress Score" },
  { name: "eyes", label: "Eyes" },
  { name: "ears", label: "Ears" },
  { name: "nasal", label: "Nasal" },
  { name: "oralDental", label: "Oral" },
  { name: "cardiovascular", label: "Cardiovascular" },
  { name: "respiratory", label: "Respiratory" },
  { name: "neurological", label: "Neurological" },
  { name: "musculoskeletal", label: "Musculoskeletal" },
  { name: "lymphatic", label: "Lymphatic" },
  { name: "gastrointestinal", label: "Gastrointestinal" },
  { name: "reproductiveUrinary", label: "Reproductive & Urinary" },
  { name: "furSkin", label: "Integument" },
  { name: "masses", label: "Masses" },
] as const;

/** Defaults shown to vets only behind the useGptUnstableObjectiveDefaults flag. */
export const UNSTABLE_OBJECTIVE_DEFAULTS: readonly string[] = [
  "nasal",
  "masses",
  "mucousMembranes",
];
